<template>
  <div class="title-bar">
    <IneSmallLogo class="title-bar__ine-logo" />
    <div class="title-bar__content">
      <ActionLoader
        v-if="isLoading"
        name="ball-clip-rotate"
        color="#fff"
        :size="0.75"
      />
      <div v-else class="title-bar__content-loaded">
        <GitHubIcon
          class="title-bar__icon svg-white"
          v-if="labType === 'github'"
        />
        <AzureIcon
          class="title-bar__icon svg-white"
          v-if="labType === 'azure'"
        />
        <ELSLabIcon
          class="title-bar__icon title-bar__icon--els svg-white"
          v-if="labType === 'els'"
        />
        <div class="title-bar__title-wrapper">
          <h4 class="title-bar__title">{{ lab.name }}</h4>
        </div>
        <div class="title-bar__status">
          Activity Status:
          <span
            class="title-bar__status__pill"
            :class="`title-bar__status__pill--${labStatus}`"
            >{{ labStatus }}</span
          >
        </div>
        <div class="title-bar__report-issue" @click.stop="$emit('start-issue')">
          <IssueIcon class="title-bar__report-issue__icon" />
          Report an issue
        </div>
      </div>
    </div>
    <div class="title-bar__close-modal">
      <button @click="$emit('close-modal')" class="title-bar__close-modal-btn">
        <CloseIcon fill="#FFFFFF" class="title-bar__close-icon" />
      </button>
    </div>
  </div>
</template>

<script>
import GitHubIcon from '@/assets/icons/course/lab/github-icon.svg'
import AzureIcon from '@/assets/icons/course/lab/azure-icon.svg'
import ELSLabIcon from '@/assets/icons/course/lab/els-lab-icon.svg'
import CloseIcon from '@/assets/icons/close_icon.svg'
import IneSmallLogo from '@/assets/icons/course/exercise/ine-small-logo.svg'
import IssueIcon from '@/assets/icons/course/bug.svg'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import CONSTANTS from '@/constants'

export default {
  name: 'TitleBarLab',
  components: {
    GitHubIcon: { ...GitHubIcon, name: 'GitHubIcon' },
    AzureIcon: { ...AzureIcon, name: 'AzureIcon' },
    ELSLabIcon: { ...ELSLabIcon, name: 'ELSLabIcon' },
    CloseIcon: { ...CloseIcon, name: 'CloseIcon' },
    IneSmallLogo: { ...IneSmallLogo, name: 'IneSmallLogo' },
    IssueIcon: { ...IssueIcon, name: 'IssueIcon' },
    ActionLoader,
  },
  props: {
    lab: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    labStatus() {
      return this.lab.user_status || CONSTANTS.CONTENT_USER_STATUS.UNSTARTED
    },
    hasCompleted() {
      if (this.labStatus === CONSTANTS.CONTENT_USER_STATUS.FINISHED) {
        return '#00DEA0'
      }
      return '#727276'
    },
    labType() {
      return this.lab.lab_type || ''
    },
  },
}
</script>

<style lang="scss" scoped>
.title-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  padding: 30px 20px 30px 20px;
  z-index: 204;
  background: var(--dark-gray);
  border-top: 5px solid var(--orange);
  border-bottom: 1px solid #424040;
  max-height: 100px;
  &__ine-logo {
    margin-right: 38px;
  }
  &__content {
    display: flex;
    align-items: center;
    flex-grow: 1;
    :global(.action-loader__loader) {
      margin-top: 14px;
    }
    &-loaded {
      display: flex;
      align-items: center;
      flex-grow: 1;
    }
  }
  &__icon {
    width: 28px;
    margin-top: 5px;
    &--els,
    &--pta {
      width: 18px;
    }
    .svg {
      fill: white;
    }
  }
  &__title-wrapper {
    flex-grow: 1;
  }
  &__title {
    margin: 0;
    padding: 0;
    font-size: 1rem;
    line-height: 1rem;
    display: none;
    color: white;
    margin-left: 15px;
    @include mobile {
      display: block;
    }
    @include desktop {
      font-size: 18px;
      line-height: 2.5rem;
      margin-top: 3px;
    }
  }
  &__close-modal {
    display: flex;
    align-items: center;
    margin-left: 20px;
  }
  &__close-text {
    display: none;
    color: var(--lighter-gray);
    font-size: 16px;
    margin: 0;
    @include desktop {
      display: block;
    }
  }
  &__close-modal-btn {
    background: none;
    border: none;
    cursor: pointer;
    &:hover {
      opacity: 0.5;
    }
  }
  &__close-icon {
    margin: 8px 0 0 0;
    color: var(--black);
  }
  &__status {
    margin-left: auto;
    color: var(--white);
    text-transform: uppercase;
    display: flex;
    white-space: nowrap;
    align-content: center;
    align-items: center;
    font-size: 12px;
    &__pill {
      padding: 9px 14px;
      background: #151515;
      border-radius: 20px;
      position: relative;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      border: 2px solid #2b2c31;
      margin-left: 10px;
      &--finished {
        background: #70ffd4;
        border: none;
        color: var(--black);
      }
    }
  }
  &__report-issue {
    display: flex;
    align-items: center;
    margin-left: 30px;
    font-size: 14px;
    color: white;
    cursor: pointer;
    &__icon {
      margin-right: 5px;
      fill: white;
    }
  }
}
</style>
